import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    this.input = this.element.querySelector('input[type="text"]');

		if (!this.input)
			return;

		this.input.insertAdjacentHTML('afterend', '<span class="hidden valid-check" data-tippy-content="Esse número de telefone tem o formato válido para o envio de SMS e Whatsapp"><i class="fab fa-whatsapp text-sm"></i> válido para whatsapp e sms</span>');
		this.input.insertAdjacentHTML('afterend', '<span class="hidden invalid-check text-danger" data-tippy-content="Esse número de telefone possui um formato inválido para o envio de SMS e Whatsapp"><i class="fas fa-times-circle text-rose"></i> inválido para o envio</span>');
		this.validCheck = this.element.querySelector('.valid-check');
		this.invalidCheck = this.element.querySelector('.invalid-check');
		this.input.addEventListener('blur', (ev) => this.onChangeNumber());
	}

	onChangeNumber() {
		if (this.input.value.length == 0)
			return;

		this.updateCheckMessage(/^\d{10,11}$/.test(this.input.value.replace(/\D/gi, '')));
	}

	updateCheckMessage(valid) {
		this.validCheck.classList.toggle('hidden', !valid);
		this.invalidCheck.classList.toggle('hidden', valid);
	}
}